"use client"

import { Image } from "@/app/components/image"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { useBlockchain } from "../use-blockchain"

interface Props {
  className?: string
  blockchain: Blockchain
}

export function BlockchainIcon(props: Props) {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<Skeleton className="h-full w-full rounded-full" />}>
        <BlockchainIconView {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}

const BlockchainIconView = reatomComponent<Props>(
  ({ className, blockchain }) => {
    const { icon, name } = useBlockchain(blockchain)

    return <Image className={className} imageSrc={icon} alt={`${name} icon`} />
  },
  "BlockchainIconView",
)
